import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFFFFF",
    },
    secondary: {
      main: "#8B8CA7",
    },
    gray16: {
      main: "#4F5069",
    },
    gray18: {
      main: "#3B3C4E",
    },
  },

  typography: {
    fontFamily: "poppins",
    color:"#FFFFFF"
  },

  // components: {
  //   MuiButton: {
  //     styleOverrides: {
  //       contained: {
  //         background:
  //           // "#3B3C4E",
  //           "linear-gradient(277.72deg, #78AFCF -2.06%, #8FDDD9 90.6%)",
  //       },
  //     },
  //   },
  // },
});

export default theme;
